import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = () => ['stagesLifeCirle'];

const fetchStages = async () => {
  const res = await request.get(
    `/FlatsGrid/stage_address_life_cycle`,
    null,
    'Не удалось загрузить стадии помещения'
  );
  return res;
};

const useStagesQuery = (options) => useQuery(key(), fetchStages, options);

export { useStagesQuery };
